'use client';

import type React from 'react';
import type { FieldValues } from 'react-hook-form';

import {
  BasicFormPattern,
  type BasicFormPatternPropsType,
} from '~/shared/components/form-block/patterns/basic-form-pattern';
import { PatternP2, type PatternP2PropsType } from '~/shared/components/form-block/patterns/pattern-p2';
import { PatternP3, type PatternP3PropsType } from '~/shared/components/form-block/patterns/pattern-p3';
import { PatternP4, type PatternP4PropsType } from '~/shared/components/form-block/patterns/pattern-p4';
import type { FormConfigType, FormPatternName } from '~/shared/types/form-type';

const PATTERN_COMPONENTS: Record<
  FormPatternName,
  React.ComponentType<BasicFormPatternPropsType | PatternP2PropsType | PatternP3PropsType | PatternP4PropsType>
> = {
  basicFormPattern: BasicFormPattern,
  p2: PatternP2,
  p3: PatternP3,
  p4: PatternP4,
};

export const getPattern = <TFieldValues extends FieldValues>(
  props: FormConfigType<TFieldValues> & Record<string, unknown>,
) => {
  const PatternComponent = PATTERN_COMPONENTS[props.pattern] ?? BasicFormPattern;
  return <PatternComponent {...props} />;
};
